// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// Import main styles
import './index.css';
// import setupErrorHandler from './utils/errorHandler';

// Import web fonts
// import '@fontsource/poppins/300.css';
// import '@fontsource/poppins/400.css';
// import '@fontsource/poppins/500.css';
// import '@fontsource/poppins/600.css';
// import '@fontsource/poppins/700.css';

// Add global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Handle session expiration errors gracefully
  if (event.reason?.message?.includes('Session expired') || 
      event.reason?.status === 401) {
    // Prevent the error from showing in console
    event.preventDefault();
    
    // Log for debugging if needed
    console.log('Session expired - handled gracefully');
    
    // The auth store will handle redirecting to login
    // No need to show error to user as it's already handled
  }
});

// Create the root
const root = ReactDOM.createRoot(document.getElementById('root'));
// setupErrorHandler();

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

